import type { ReactNode } from 'react';

export const symbol_bookmarks: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m400-199-197 98q-15 8-29-.75T160-128v-533q0-24.75 17.63-42.38Q195.25-721 220-721h360q24.75 0 42.38 17.62Q640-685.75 640-661v533q0 17.5-14 26.25t-29 .75l-197-98Zm-180 22 153-76q12.72-6 26.86-6 14.14 0 27.14 6l153 76v-484H220v484Zm528.5-70.63Q740-256.25 740-269v-552H314q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h426q24.75 0 42.38 17.62Q800-845.75 800-821v552q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63ZM220-661h360-360Z"
		/>
	</svg>
);
